import { ITaskBlock } from 'shared/express-interface/blocks-core/ITaskBlock'

export type RatingsTaskUiProps = {
    blocks: ITaskBlock[]
}

export const RatingsTaskUi = (props: RatingsTaskUiProps) => {
    return (
        <div className="summarize-root" data-testid="maker-ui-wrapper">
            {props.blocks.map(block => block.getElement()?.element)}
        </div>
    )
}
